import { useEffect, useState } from 'react';
import { FileServicesBack } from '../../services/api/files/FileServicesBack';
import { Autocomplete, TextField } from '@mui/material';

interface SelectTypeFileProps {
	value: string;
	onChange: (value: string) => void;
	error: boolean,
}

export default function SelectTypeFile({
	value,
	onChange,
	error
}: SelectTypeFileProps) {

	const [data, setData] = useState<string[]>([]);


	useEffect(() => {
		async function getTypes() {
			try {
				const response = await FileServicesBack.getFileType();
				if (response instanceof Error) {
					console.log('Erro ao buscar tipos', response.message);
				} else {
					setData([...response].sort((a, b) => a.localeCompare(b)));
				}
			} catch (error) {
				throw new Error(`Erro ao buscar tipos: ${error}`);
			}
		}
		getTypes();
	}, []);

	const handleSelectChange = (
		_event: React.SyntheticEvent,
		newValue: string | null
	) => {
		onChange(newValue ?? '');
	};

	return (
		<Autocomplete
			options={data}
			getOptionLabel={(option) => String(option)}
			value={value}
			id='selectType'
			onChange={handleSelectChange}
			renderInput={(params) => (
				<TextField required {...params} label='Tipo de arquivo' error={error} fullWidth/>
			)}
		/>
	);
}